<div class="brand-div">
  <a class="navbar-brand" href="#">
    <img class="navbar-logo"
         width="100px"
         alt="logo international"
         [src] = 'logoSrc'/>
  </a>
</div>

